import * as client_hooks from '../../../../src/hooks.client.ts';
import * as universal_hooks from '../../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39')
];

export const server_loads = [2,4,5];

export const dictionary = {
		"/(marketing)": [~37,[6]],
		"/(app)/admin/data": [7,[2,3]],
		"/(app)/admin/invoicing": [~8,[2,3]],
		"/(app)/admin/invoicing/[org]": [9,[2,3]],
		"/(app)/admin/lexicon": [10,[2,3]],
		"/(app)/admin/maintenance": [11,[2,3]],
		"/(app)/admin/memory": [12,[2,3]],
		"/(app)/admin/problems": [13,[2,3]],
		"/(app)/admin/problems/[id]": [14,[2,3]],
		"/(app)/admin/usage": [15,[2,3]],
		"/(marketing)/ai-principles": [38,[6]],
		"/(app)/home": [~16,[2]],
		"/(marketing)/privacy": [39,[6]],
		"/(app)/runs": [~17,[2]],
		"/(app)/runs/[...runPath=runPath]/human-step/annotations": [~20,[4]],
		"/(app)/runs/[...runPath=runPath]/human-step/assessment": [~21,[4]],
		"/(app)/runs/[...runPath=runPath]/human-step/consistency-steps": [~23,[4]],
		"/(app)/runs/[...runPath=runPath]/human-step/consistency": [~22,[4]],
		"/(app)/runs/[...runPath=runPath]/human-step/language-edit": [~24,[4]],
		"/(app)/runs/[...runPath=runPath]/human-step/navigate": [~25,[4]],
		"/(app)/runs/[...runPath=runPath]/human-step/questions": [~26,[4]],
		"/(app)/runs/[...runPath=runPath]/human-step/workflow-selection": [~27,[4]],
		"/(app)/runs/[...runPath=runPath]/human-step/[plugin]": [~19,[4]],
		"/(app)/runs/[...runPath=runPath]": [~18,[2]],
		"/(app)/settings": [~28,[2]],
		"/(app)/settings/organization": [~29,[2]],
		"/(app)/training/references": [~30,[2,5]],
		"/(app)/training/references/id/[id]": [~31,[2,5]],
		"/(app)/training/references/import": [32,[2,5]],
		"/(app)/training/references/list": [~33,[2,5]],
		"/(app)/training/references/stats": [~34,[2,5]],
		"/(app)/workflows": [~35,[2]],
		"/(app)/workflows/[...workflowPath]": [~36,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);